import { useCallback, useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  Col,
  Modal,
  Row,
  Space,
  Table,
  Tabs,
  message,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import columnZone from "./table/data.table";
import FormEdit from "./components/form.edit";
import Department from "./components/deparment";
import requets from "../../api";
import ReportExcel from "../../api/service/report/reportExcel";
import { ReportCsv } from "../../api/service/report/reportCsv";
import { useAppAuth } from "../../context/use-app-auth";

export default function Location() {
  const auth = useAppAuth();
  const req = useMemo(() => requets(auth.user?.access_token), [auth.user?.access_token]);
  const { t } = useTranslation("global");
  const [messageSend, contextHolder] = message.useMessage();
  const [data, setDataSource] = useState([]);
  const [departament, setDepartament] = useState([]);
  const [departamentWithState, setDepartamentWithState] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editLocation, setEditLocation] = useState(null);

  const getDepartmentWithState = useCallback(() => {
    req.get("/department/?state=true").then((response) => {
      const raw = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      setDepartamentWithState(
        raw.map((d) => ({
          value: d.value ?? d.uuid,
          label: d.label ?? d.name,
          state: d.state,
        }))
      );
    });
  }, [req]);

  const getLocations = useCallback(() => {
    req.get("/locations").then((response) => {
      const locations = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      setDataSource(locations);
    });
  }, [req]);

  const openCreateModal = () => {
    setEditLocation(null);
    setModalOpen(true);
  };

  const openEditModal = async (key) => {
    try {
      const response = await req.get(`/locations/${key}`);
      if (response.status === 200) {
        setEditLocation(response.data);
        setModalOpen(true);
      }
    } catch {
      messageSend.error(t("deviceEdit.error"));
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    setEditLocation(null);
  };

  const onSaveSuccess = () => {
    getLocations();
    closeModal();
  };

  useEffect(() => {
    req.get("/department?state=false&limit=100").then((response) => {
      const result = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      setDepartament(result);
    });
    getDepartmentWithState();
    getLocations();
  }, [req, getDepartmentWithState, getLocations]);

  const items = [
    {
      key: "1",
      label: t("zones.department"),
      children: (
        <Department
          departament={departament}
          refreshDepartment={getDepartmentWithState}
        />
      ),
    },
    {
      key: "2",
      label: t("zones.sellingLocation"),
      children: (
        <>
          {contextHolder}
          <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
            <Col>
              <Button
                type="primary"
                shape="round"
                icon={<PlusOutlined />}
                onClick={openCreateModal}
              >
                {t("zones.newLocation") || "Nueva ubicación"}
              </Button>
            </Col>
            <Col>
              <Space>
                <ReportExcel dataSet={data} fileName="reporte-puntos-de-ventas" />
                <ReportCsv dataSet={data} />
              </Space>
            </Col>
          </Row>

          <Table
            columns={columnZone(getLocations, openEditModal)}
            dataSource={data}
            scroll={{ x: "calc(700px + 50%)" }}
            rowKey="uuid"
          />

          <Modal
            open={modalOpen}
            onCancel={closeModal}
            footer={null}
            title={
              editLocation
                ? t("zones.editLocation") || "Editar ubicación"
                : t("zones.newLocation") || "Nueva ubicación"
            }
            width={860}
            destroyOnClose
            styles={{ body: { maxHeight: "75vh", overflowY: "auto", paddingRight: 8 } }}
          >
            <FormEdit
              editLocation={editLocation}
              departament={departamentWithState}
              onSaveSuccess={onSaveSuccess}
              onCancel={closeModal}
            />
          </Modal>
        </>
      ),
    },
  ];

  return (
    <div className="layout-content">
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col xs={24} className="mb-24">
          <Card bordered={false}>
            <Tabs defaultActiveKey="2" items={items} />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
